import { TypeLoyaliyMainName } from "@/types";
import { TypeCertificateObj } from "@/types/typesOfApi";

export default function createAddFieldsForCertifcate(certificateTypes: any) {
  for (const typeName in certificateTypes) {
    const minutesSet = new Set();
    const nominalsSet = new Set();
    const currentCertificateType: TypeLoyaliyMainName =
      certificateTypes[typeName];

    currentCertificateType.list.forEach((item: TypeCertificateObj) => {
      const currentTitleSplit: string[] = item.title.split("/");

      minutesSet.add(currentTitleSplit[1]);
      nominalsSet.add(item.balance);
    });
    const title = typeName.replace(/_/g, " ").trim();

    currentCertificateType.title = title;
    currentCertificateType.minutesArray = Array.from(minutesSet);
    currentCertificateType.nominalsArray = Array.from(nominalsSet);
  }
}